// MyLoansPage.jsx
import * as React from "react";
import {
  ThemeProvider,
  createTheme,
  CssBaseline,
  AppBar,
  Toolbar,
  Typography,
  Container,
  Box,
  Stack,
  Tabs,
  Tab,
  IconButton,
  Badge,
  Avatar,
  TextField,
  InputAdornment,
  Select,
  MenuItem,
  Grid,
  Paper,
  Card,
  CardContent,
  CardActions,
  Button,
  Chip,
  LinearProgress,
  Fab,
  Divider,
} from "@mui/material";
import { alpha } from "@mui/material/styles";
import {
  AccountBalance,
  NotificationsNone,
  Search,
  Add,
} from "@mui/icons-material";
import { formatNumberWithCommas } from "../../../../utils/generalFunctions";
import { useNavigate } from "react-router-dom"; 
const theme = createTheme({
  palette: {
    primary: { main: "#1976D2" }, // matches your --primary-color
    background: { default: "#F8F9FA" }, // --background-color
    text: {
      primary: "#1A202C", // --text-primary
      secondary: "#6B7280", // --text-secondary
    },
    success: { main: "#22C55E" }, // status-active
    warning: { main: "#F59E0B" }, // status-pending
    grey: { 600: "#9CA3AF" }, // status-closed
    error: { main: "#EF4444" }, // overdue red
  },
  typography: {
    fontFamily: ['Inter', 'Roboto', 'Helvetica', 'Arial', 'sans-serif'].join(","),
  },
});

function StatCard({ label, value }) {
  return (
    <Paper elevation={0} sx={{ p: 2.5, backgroundColor:"white" }}>
      <Typography variant="body2" color="text.secondary" fontWeight={600}>
        {label}
      </Typography>
      <Typography variant="h5" mt={0.5}>
        {value}
      </Typography>
    </Paper>
  );
}

function OverdueCard({ label, value }) {
  return (
    <Paper
      variant="outlined"
      sx={(t) => ({
        p: 2.5,
        bgcolor: alpha(t.palette.error.main, 0.08),
        borderColor: alpha(t.palette.error.main, 0.4),
      })}
    >
      <Typography variant="body2" fontWeight={600} color="error.main">
        {label}
      </Typography>
      <Typography variant="h5" mt={0.5} color="error.main">
        {value}
      </Typography>
    </Paper>
  );
}

function StatusChip({ status }) {
  const map = {
    activo: { color: "success", label: "Activo" },
    irrecuperable: { color: "warning", label: "Pendiente" },
    atrasado: { color: "error", label: "Atrasado" },
    cancelado: { color: "error", label: "Cancelado" },
    "Pagado": { color: "default", label: "Pagado" },
  };
  const conf = map[status] || { color: "default", label: status };
  return (
    <Chip
      label={conf.label}
      color={conf.color}
      size="small"
      sx={{
        color:
          conf.color === "default" ? "common.white" : undefined,
        bgcolor:
          conf.color === "default" ? "grey.600" : undefined,
      }}
    />
  );
}

function LoanCard({
  title,
  id,
  status,
  principal,
  balance,
  nextPayment,
  progress, // 0..100
  canPay = true,
  closed = false,
  navigate,
  solicitud_id,
}) {


  return (
    <Card
      elevation={3}
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "box-shadow .2s",
        "&:hover": { boxShadow: 8 },
        backgroundColor:"white",
      }}
    >
      <CardContent sx={{ pb: 1.5 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="flex-start" mb={2}>
          <Box>
            <Typography variant="subtitle1" fontWeight={600}>
              {title}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              ID: {id}
            </Typography>
          </Box>
          <StatusChip status={status} />
        </Stack>

        <Stack spacing={1.0} mb={2}>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Principal:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {principal}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              Saldo:
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {balance}
            </Typography>
          </Stack>
          <Stack direction="row" justifyContent="space-between">
            <Typography variant="body2" color="text.secondary">
              {closed ? "Estado:" : "Próximo Pago:"}
            </Typography>
            <Typography variant="body2" fontWeight={600}>
              {closed ? "Cerrado" : nextPayment}
            </Typography>
          </Stack>
        </Stack>

        <Box>
            <Divider sx={{ marginTop: 5 }} />
{/*          <LinearProgress
            variant="determinate"
            value={progress}
            sx={{
              height: 10,
              borderRadius: 999,
              "& .MuiLinearProgress-bar": { borderRadius: 999 },
            }}
          />*/}
        </Box>
      </CardContent>

      <CardActions sx={{ mt: "auto", p: 2, pt: 0, gap: 1, flexWrap: "wrap" }}>
        <Button variant="outlined" color="primary" fullWidth sx={{ flex: 1 }} onClick={()=>{navigate(`/gestion_comercial/prestamos/detalle/${solicitud_id}`)}}>
          Ver Detalles
        </Button>
        <Button
          variant="contained"
          color="primarybutton"
          fullWidth
          sx={{ flex: 1 , fontWeight:"bold"}}
          disabled={!canPay}
        >
          {closed ? "Contactar Soporte" : "Realizar Pago"}
        </Button>
      </CardActions>
    </Card>
  );
}

export default function Loans({prestamos}) {
  const [tab, setTab] = React.useState("Loans");
  const [prestamosData, setPrestamosData] = React.useState([]);
  const navigate = useNavigate();
  console.log(prestamos);

  React.useEffect(() => {
    setPrestamosData(prestamos.filter(prestamo => prestamo.id!=null));
    
  }, []);
  return (
    <>
      

      {/* Page */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        {/* Title */}
        <Box mb={3} textAlign={"left"}>
          <Typography variant="h4" fontWeight={800}>
            Mis Préstamos
          </Typography>
          <Typography variant="body1" color="text.secondary" mt={0.5}>
            Rastrea tus préstamos activos, pendientes y pagados.
          </Typography>
        </Box>

        {/* Filters */}
        <Paper variant="outlined" sx={{ bgcolor: "white", p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center" >
          <Grid item size={6}>
            <TextField
              fullWidth
              placeholder="Buscar por ID de Préstamo, Nombre del Producto..."
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Search color="action" />
                  </InputAdornment>
                ),
              }}
            />
          </Grid>
          <Grid item size={6}>
            <Stack direction="row" spacing={2}>
              <Select defaultValue="All" size="medium" sx={{ minWidth: 180, backgroundColor:"white" }}>
                <MenuItem value="All">Todos los Estados</MenuItem>
                <MenuItem value="Active">Activo</MenuItem>
                <MenuItem value="Pending">Pendiente</MenuItem>
                <MenuItem value="Paid Off">Pagado</MenuItem>
              </Select>
              <TextField type="date" />
            </Stack>
          </Grid>
        </Grid>
        </Paper>

       

        {/* Loans Grid */}
        <Grid container spacing={3}>
          {prestamosData.map((prestamo) => (
          <Grid item size={6}>
            <LoanCard
              navigate={navigate}
              title={JSON.parse(prestamo.generales).nombre}
              id={prestamo.loan_id}
              solicitud_id={prestamo.solicitud_id}
              status={prestamo.atraso ? "atrasado" : prestamo.estado}
              principal={formatNumberWithCommas(prestamo.monto_solicitado)}
              balance={formatNumberWithCommas((parseFloat(prestamo.capitalPendiente)+parseFloat(prestamo.interesPendiente)).toFixed(2))}
              nextPayment={prestamo.proxima_cuota}
              progress={75}
              canPay
            />
          </Grid>
          ))}
        </Grid>
      </Container>

      {/* FAB 
      <Fab
        color="primary"
        variant="extended"
        sx={{ position: "fixed", right: 24, bottom: 24, boxShadow: 6 }}
      >
        <Add sx={{ mr: 1 }} />
        Solicitar Nuevo Préstamo
      </Fab>
      */}
    </>
  );
}
